import script from "./informItemStudy.vue?vue&type=script&setup=true&lang=js"
export * from "./informItemStudy.vue?vue&type=script&setup=true&lang=js"

import "./informItemStudy.vue?vue&type=style&index=0&id=4ed60d6a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed60d6a"]])

export default __exports__